import { FINANCE_V2_HOSTNAME, INTRANETHOSTNAME} from '../../../../common-utilities/utils/end-points';
import { HTTP_METHODS, invokeApi } from '../../../utils/http-service';
import { FINANCE_REST_URLS } from '../../../../common-utilities/utils/end-points/finance-v2';
import { toast } from 'react-toastify';
import { getCreateUpdateDetails } from './utils';
import { setProperty } from '../../../../common-utilities/utils/misc';

export const queryExtraCharges = (filters, setDataFunc, setFilters) => {
  invokeApi(
    HTTP_METHODS.GET,
    `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.EXTRA_CHARGE}`,
    null,
    filters
  )
    .then((res) => {
      if (res?.message) {
        if (typeof setDataFunc == 'function') {
          setDataFunc({});
        }
        if (
          filters?.page > res?.totalPages &&
          typeof setFilters === 'function'
        ) {
          setProperty('page', res?.totalPages, setFilters);
        }

        return;
      }
      if (typeof setDataFunc == 'function') {
        setDataFunc(res);
      }
    })
    .catch((err) => {
      if (typeof setDataFunc == 'function') {
        setDataFunc({});
      }
      console.log(err);
    });
};

export const getApplicableExtraCharges = (onSuccess) => {
  invokeApi(
    HTTP_METHODS.GET,
    `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.EXTRA_CHARGE}/applicable`
  )
    .then((res) => {
      if (res?.message || !Array.isArray(res)) {
        return;
      }
      onSuccess(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const loadDepartmentOptions = (setDepartmentList) => {
  invokeApi(
    HTTP_METHODS.GET,
    `${INTRANETHOSTNAME}${FINANCE_REST_URLS.DEPARTMENTS}`
  )
    .then((res) => {
      if (res?.message || !Array.isArray(res)) {
        return;
      }
      setDepartmentList(
        res.map((ele) => ({ label: ele?.name, value: ele?._id }))
      );
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteExtraCharge = (id, onSuccess) => {
  invokeApi(
    HTTP_METHODS.DELETE,
    `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.EXTRA_CHARGE}/${id}`,
    null
  )
    .then((res) => {
      if (res?.message) {
        toast.error(res?.message, { autoClose: 2000 });
        return;
      }
      toast.success('Extra charge deleted successfully', {
        autoClose: 2000,
      });
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    })
    .catch((err) => {
      console.log(err?.message, { autoClose: 2000 });
    });
};

export const createUpdateExtraCharge = (data, onSuccess) => {
  const { method, payload, url, message } = getCreateUpdateDetails(data);
  invokeApi(method, url, payload)
    .then((res) => {
      if (res?.message) {
        toast.error(res?.message);
        return;
      }
      toast.success(message, { autoClose: 2000 });
      onSuccess && onSuccess();
    })
    .catch((err) => {
      console.log(err?.message, { autoClose: 2000 });
    });
};
